export const LenderVariables = {
    numberOfLenders: 15,
    numberOfProducts: 200
}